import React from 'react'

import RBModal from 'react-bootstrap/Modal'
import { ModalProps } from './types'

export const Modal = ({
  header,
  show,
  onHide,
  onShow,
  size = '',
  headerSubline,
  content,
  children,
  footer,
  id,
}: ModalProps): JSX.Element => {
  return (
    <RBModal show={show} onShow={onShow} onHide={onHide} on dialogClassName={size} id={id}>
      <RBModal.Header>
        <RBModal.Title>
          <p className="m-0">{header}</p>
          {headerSubline && <h5>{headerSubline}</h5>}
        </RBModal.Title>
        <button type="button" className="modal-close" aria-label="Close" onClick={onHide}></button>
      </RBModal.Header>

      <RBModal.Body>
        {content}
        {children}
      </RBModal.Body>

      {footer && <RBModal.Footer>{footer}</RBModal.Footer>}
    </RBModal>
  )
}
